import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CreateMenuDto, MenuService as MenuApiService, UpdateMenuDto } from '@rezevent/api-types';

@Injectable({ providedIn: 'root' })
export class MenuService {
  private _api = inject(MenuApiService);

  refresh$ = new Subject<void>();

  list$ = this._api.menuControllerFindAll();

  delete$(id: string) {
    return this._api.menuControllerRemove(id);
  }

  create(requestParams: CreateMenuDto) {
    return this._api.menuControllerCreate(requestParams);
  }

  edit(id: string, input: UpdateMenuDto) {
    return this._api.menuControllerUpdate(id, input);
  }
}
